import React, { FC } from 'react'
import { QuantiteUcDisplayable, Sortie } from '../services/sortie.types'
import { Grid, withStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { FormattedMessage } from 'react-intl'
import { getStyles } from 'isotope-client'
import SortieDialogBody from './SortieDialogBody'

const styles = () => getStyles({
	container: {
		margin: '12px 24px',
		maxWidth: 400
	}
})

type DeleteSortieDialogProps = {
	sortie: Sortie
	quantiteUcDisplayable: QuantiteUcDisplayable
	classes: ClassNameMap
}

/**
 * Dialog de confirmation de suppression d'une sortie
 */
const DeleteSortieDialog: FC<DeleteSortieDialogProps> = ({ sortie, quantiteUcDisplayable, classes }) => {
	return <Grid container className={classes.container}>
		<Grid item xs={12}>
			<Typography variant="h5"><FormattedMessage id="sorties.history.deletion.body" /></Typography>
		</Grid>
		<SortieDialogBody sortie={sortie} quantiteUcDisplayable={quantiteUcDisplayable} showCommentaire />
	</Grid>
}

export default withStyles(styles)(DeleteSortieDialog)